export const get_payment_method_groups_query = `
    query Payment_method_groups ($currency: String, $format: PaymentMethodOptionsFormat!, $sort: String, $decline_recovery_type: PaymentMethodOptionsDeclineRecoveryType) {
    payment_method_groups(currency: $currency, format: $format, sort: $sort, decline_recovery_type: $decline_recovery_type) {
      key
      title
      arrival_time
      arrival_time_type
      payment_methods {
        key
        title
        option_id
        option_type
        image
        image_dark_mode
        payout_condition
        is_obt_supported
        recently_used
        recently_used_template {
          token
          label
          expiration
          payment_rail {
            key
            title
          }
        }
        payment_information {
          currency
          rate
          limits  {
            min_amount
            max_amount
          }
          fees {
            flat_fee_amount
            percentage_fee
            is_included
            min_transaction_amount
            max_transaction_amount
            min_fee_amount
            max_fee_amount
          }
        }
        payment_rails {
          key
          title
        }
        maintenance {
          enabled
          start_date
          end_date
        }
      }
    }
  }
`;
